import { OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (colArr, quarterIdx: number): number => {
  return colArr[quarterIdx].months.length + 1;
};

export const calculateEachProductTotal = (quarters, measureName: string) => {
  const total = quarters.reduce((qInit, quarter) => {
    qInit += quarter.value;
    return qInit;
  }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateProductTotal = (rowArr, rIdx: number, pIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateEachProductTotal(rowArr[unitIdx].products[pIdx].quarters, 'Plan / Quota - UNITS');
    const totalValue = calculateEachProductTotal(rowArr[valueIdx].products[pIdx].quarters, 'Plan / Quota - $');

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateEachProductTotal(rowArr[planQuotaIdx].products[pIdx].quarters, 'Plan / Quota - $');
    let totalMargin;

    if (rowArr[marginIdx].products[pIdx]) {
      totalMargin = calculateEachProductTotal(rowArr[marginIdx].products[pIdx].quarters, 'Margin $');
    }

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateEachProductTotal(rowArr[rIdx].products[pIdx].quarters, measureName);
};

export const calculateMeasureTotal = (products, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += calculateEachProductTotal(product.quarters, measureName);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateMeasurePct = (products, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += calculateEachProductTotal(product.quarters, measureName);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateQuarterValue = (rowArr, rIdx: number, pIdx: number, qIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = Math.round(rowArr[unitIdx].products[pIdx].quarters[qIdx].value);
    const totalValue = rowArr[valueIdx].products[pIdx].quarters[qIdx].value;

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = rowArr[planQuotaIdx].products[pIdx].quarters[qIdx].value;
    const totalMargin = rowArr[marginIdx].products[pIdx].quarters[qIdx].value;

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = rowArr[rIdx].products[pIdx].quarters[qIdx].value;
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateMeasureAverage = (rowArr, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateMeasureTotal(rowArr[unitIdx].products, 'Plan / Quota - UNITS');
    const totalValue = calculateMeasureTotal(rowArr[valueIdx].products, 'Plan / Quota - $');

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateMeasureTotal(rowArr[planQuotaIdx].products, 'Plan / Quota - $');
    const totalMargin = calculateMeasurePct(rowArr[marginIdx].products, 'Margin $');

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return 0;
};

export const calculateQuarterTotal = (products, qIdx: number, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateQuarterPct = (products, qIdx: number, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].months.reduce((mInit, month) => {
        mInit += month.value;
        return mInit;
      }, 0);
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateQuarterTotalForEachMeasure = (
  rowArr,
  rIdx: number,
  pIdx: number,
  qIdx: number,
  measureName: string
): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateQuarterTotal(rowArr[unitIdx].products, qIdx, 'Plan / Quota - UNITS');
    const totalValue = calculateQuarterTotal(rowArr[valueIdx].products, qIdx, 'Plan / Quota - $');

    return Math.round(totalValue / totalUnit);
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateQuarterTotal(rowArr[planQuotaIdx].products, qIdx, 'Plan / Quota - $');
    const totalMargin = calculateQuarterPct(rowArr[marginIdx].products, qIdx, 'Margin $');

    return OneDecimalPlace((totalMargin / totalPlanQuota) * 100);
  }

  return calculateQuarterTotal(rowArr[rIdx].products, qIdx, measureName);
};

export const calculateVerticalWeekTotal = (products, qIdx: number, mIdx: number, measureName: string): number => {
  const total = products
    .filter((product, idx) => products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].months[mIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateHorizontalWeekTotal = (months, measureName: string): number => {
  const total = months.reduce((mInit, month) => {
    mInit += month.value;
    return mInit;
  }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateWeekPct = (products, qIdx: number, mIdx: number, measureName: string): number => {
  const total = products
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].months[mIdx].value;
      return pInit;
    }, 0);

  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateWeekTotalForEachMeasure = (rowArr, rIdx: number, pIdx: number, qIdx: number, mIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalWeekTotal(rowArr[unitIdx].products, qIdx, mIdx, 'Plan / Quota - UNITS');
    const totalValue = calculateVerticalWeekTotal(rowArr[valueIdx].products, qIdx, mIdx, 'Plan / Quota - $');

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalWeekTotal(rowArr[planQuotaIdx].products, qIdx, mIdx, 'Plan / Quota - $');
    const totalMargin = calculateWeekPct(rowArr[marginIdx].products, qIdx, mIdx, 'Margin $');

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = calculateVerticalWeekTotal(rowArr[rIdx].products, qIdx, mIdx, measureName);
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateWeekValue = (rowArr, rIdx: number, pIdx: number, qIdx: number, mIdx: number, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = rowArr[unitIdx].products[pIdx].quarters[qIdx].months[mIdx].value;
    const totalValue = rowArr[valueIdx].products[pIdx].quarters[qIdx].months[mIdx].value;

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = rowArr[planQuotaIdx].products[pIdx].quarters[qIdx].months[mIdx].value;
    const totalMargin = rowArr[marginIdx].products[pIdx].quarters[qIdx].months[mIdx].value;

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  const total = rowArr[rIdx].products[pIdx].quarters[qIdx].months[mIdx].value;
  return measureName === 'Plan / Quota - UNITS' ? Math.round(total) : Math.round(total);
};

export const calculateCMWeekTotalForEachMeasure = (rowArr, rIdx: number, qIdx: number, mIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMWeekTotal(rowArr, unitIdx, qIdx, mIdx, type);
    const totalValue = calculateVerticalCMWeekTotal(rowArr, valueIdx, qIdx, mIdx, type);

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMWeekTotal(rowArr, planQuotaIdx, qIdx, mIdx, type);
    const totalMargin = calculateVerticalCMWeekTotal(rowArr, marginIdx, qIdx, mIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMWeekTotal(rowArr, rIdx, qIdx, mIdx, type);
};

export const calculateVerticalCMWeekTotal = (rowArr, rIdx: number, qIdx: number, mIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += product.quarters[qIdx].months[mIdx][type];
      return pInit;
    }, 0);

  return Math.round(total);
};

export const calculateCMQuarter = (months, type: string): number => {
  const total = months.reduce((mInit, month) => {
    mInit += month[type];
    return mInit;
  }, 0);

  return Math.round(total);
};

export const calculateCMQuarterTotalForEachMeasure = (rowArr, rIdx: number, qIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMQuarterTotal(rowArr, unitIdx, qIdx, type);
    const totalValue = calculateVerticalCMQuarterTotal(rowArr, valueIdx, qIdx, type);

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMQuarterTotal(rowArr, planQuotaIdx, qIdx, type);
    const totalMargin = calculateVerticalCMQuarterTotal(rowArr, marginIdx, qIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMQuarterTotal(rowArr, rIdx, qIdx, type);
};

export const calculateVerticalCMQuarterTotal = (rowArr, rIdx: number, qIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product) => {
      pInit += calculateCMQuarter(product.quarters[qIdx].months, type);
      return pInit;
    }, 0);

  return Math.round(total);
};

export const calculateCMProduct = (rowArr, rIdx: number, pIdx: number, type: string): number => {
  const total = rowArr[rIdx].products[pIdx].quarters.reduce((qInit, quarter) => {
    qInit += calculateCMQuarter(quarter.months, type);
    return qInit;
  }, 0);

  return Math.round(total);
};

export const calculateCMProductTotalForEachMeasure = (rowArr, rIdx: number, pIdx: number, type: string, measureName: string): number => {
  if (measureName === 'Plan ASP') {
    const unitIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - UNITS');
    const valueIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const totalUnit = calculateVerticalCMProductTotal(rowArr, unitIdx, pIdx, type);
    const totalValue = calculateVerticalCMProductTotal(rowArr, valueIdx, pIdx, type);

    return totalUnit !== 0 ? Math.round(totalValue / totalUnit) : 0;
  }

  if (measureName === 'Margin %') {
    const planQuotaIdx = rowArr.findIndex((row) => row.name === 'Plan / Quota - $');
    const marginIdx = rowArr.findIndex((row) => row.name === 'Margin $');
    const totalPlanQuota = calculateVerticalCMProductTotal(rowArr, planQuotaIdx, pIdx, type);
    const totalMargin = calculateVerticalCMProductTotal(rowArr, marginIdx, pIdx, type);

    return totalPlanQuota !== 0 ? OneDecimalPlace((totalMargin / totalPlanQuota) * 100) : 0;
  }

  return calculateVerticalCMProductTotal(rowArr, rIdx, pIdx, type);
};

export const calculateVerticalCMProductTotal = (rowArr, rIdx: number, pIdx: number, type: string): number => {
  const total = rowArr[rIdx].products
    .filter((product, idx) => rowArr[rIdx].products.length - 1 !== idx)
    .reduce((pInit, product, productIdx) => {
      pInit += calculateCMProduct(rowArr, rIdx, productIdx, type);
      return pInit;
    }, 0);

  return Math.round(total);
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};
